<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>

    <v-overlay z-index="9999" :value="$overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>
